import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AfterLoginGuard } from './guards/after-login.guard';
import { NotAllowedComponent } from './shared/components/not-allowed/not-allowed.component';
import { LoginComponent } from './guest/login/login.component';
import { ForgotPasswordComponent } from './guest/forgot-password/forgot-password.component';
import { CheckYourEmailComponent } from './guest/check-your-email/check-your-email.component';
import { ResetPasswordComponent } from './guest/reset-password/reset-password.component';
import { SetPasswordComponent } from './guest/set-password/set-password.component';
import { ChangePasswordComponent } from './guest/change-password/change-password.component';
import { GuestMainPageComponent } from './guest/guest-page/guest-main-page/guest-main-page.component';
import { BeforeLoginGuard } from './guards/before-login.guard';
import { AuthenticationTemplateComponent } from './guest/authentication-template/authentication-template.component';
import { RegisterComponent } from './guest/register/register.component';
import { AccountsLayoutComponent } from './shared/components/accounts-layout/accounts-layout.component';
import { userAccountRoutes } from './modules/accounts/normal-user/user-account-routing-module';
import { VerifyOtpComponent } from './guest/verify-otp/verify-otp.component';
import { LoginWithGmsComponent } from './guest/login-with-gms/login-with-gms.component';
import { NormalUserComponent } from './modules/accounts/normal-user/normal-user.component';
import { AdminComponent } from './modules/accounts/admin/admin.component';
import { adminAccountRoutes } from './modules/accounts/admin/admin-account-routing.module';
import { AuthMessageComponent } from './guest/auth-message/auth-message.component';
import { JoinMeetingComponent } from './guest/join-meeting/join-meeting.component';
import { FeedbackformComponent } from './guest/feedbackform/feedbackform.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'not-allowed',
    component: NotAllowedComponent,
    canActivate: [AfterLoginGuard],
  },
  {
    path: 'account',
    component: NormalUserComponent,
    children: [...userAccountRoutes],
    canActivate: [AfterLoginGuard],
  },
  {
    path: 'super-admin',
    component: AdminComponent,
    children: [...adminAccountRoutes],
    canActivate: [AfterLoginGuard],
  },
  // {
  //   path: 'join-meeting',
  //   component: JoinMeetingComponent,
  //   canActivate: [BeforeLoginGuard],
  // },
  {
    path: 'auth',
    component: AuthenticationTemplateComponent,
    canActivate: [BeforeLoginGuard],
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [BeforeLoginGuard],
      },
      {
        path: 'login-with-gms',
        component: LoginWithGmsComponent,
        canActivate: [BeforeLoginGuard],
      },
      {
        path: 'register',
        component: RegisterComponent,
        canActivate: [BeforeLoginGuard],
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        canActivate: [BeforeLoginGuard],
      },
      {
        path: 'reset-password/:token',
        component: ResetPasswordComponent,
        canActivate: [BeforeLoginGuard],
      },
      {
        path: 'set-password/:token',
        component: SetPasswordComponent,
        canActivate: [BeforeLoginGuard],
      },
      {
        path: 'activate-account/:token',
        component: VerifyOtpComponent,
        canActivate: [BeforeLoginGuard],
      },
      {
        path: 'verify-phone-number',
        component: VerifyOtpComponent,
        canActivate: [BeforeLoginGuard],
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent,
        canActivate: [AfterLoginGuard],
      },
      {
        path: 'check-your-email',
        component: CheckYourEmailComponent,
        canActivate: [BeforeLoginGuard],
      },
      {
        path: 'message',
        component: AuthMessageComponent,
        canActivate: [BeforeLoginGuard],
      },
      {
        path: 'join-meeting',
        component: JoinMeetingComponent,
        canActivate: [BeforeLoginGuard],
      },
    ],
  },
  {
  path: 'home',
  component: GuestMainPageComponent,
  canActivate: [BeforeLoginGuard],
},

  {
    path: 'feedback/:meetingId',
    component: FeedbackformComponent,
  },
  { path: '**', component: NotAllowedComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
